import { ArrowRight, Lightning } from "@phosphor-icons/react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_slay-aesthetic-boost/artifacts/5mpzbdp8_sweat_with_slay_7.png";

const EVERFIT_URL = "https://invite.everfit.io/Q9TTSYVZYA";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full flex items-end overflow-hidden pt-24"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="AJ — founder of Sweat With Slay"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/95" />
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.04)_1px,transparent_1px)] bg-[size:64px_64px]" />
      </div>

      {/* Live tag top right */}
      <div className="absolute top-28 right-6 md:right-12 lg:right-20 flex items-center gap-3 z-10">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full rounded-full bg-[#FF1B91] live-dot" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-[#FF1B91]" />
        </span>
        <span data-testid="hero-live-tag" className="text-[10px] uppercase tracking-[0.3em] font-semibold text-white/70">
          Now coaching · Open enrollment
        </span>
      </div>

      {/* Side index */}
      <div className="hidden lg:flex absolute left-6 top-1/2 -translate-y-1/2 -rotate-90 origin-left text-[10px] uppercase tracking-[0.4em] text-white/40 z-10">
        Index — 01 / Hero
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-12 lg:px-20 pb-16 lg:pb-24">
        <div className="max-w-6xl">
          <p data-testid="hero-eyebrow" className="reveal text-[11px] md:text-xs uppercase tracking-[0.4em] text-[#FF1B91] font-semibold mb-6 flex items-center gap-2">
            <Lightning weight="fill" size={14} /> Custom Coaching · Digital · On Your Time
          </p>

          <h1
            data-testid="hero-headline"
            className="reveal font-display font-black uppercase leading-[0.9] tracking-tighter text-[15vw] sm:text-[13vw] md:text-[11vw] lg:text-[9.5rem] xl:text-[11rem]"
            style={{ animationDelay: "120ms" }}
          >
            <span className="block">Sweat</span>
            <span className="font-brush font-normal normal-case text-[#FF1B91] block leading-[0.85] -mt-2 md:-mt-4 -rotate-2 origin-left">
              with Slay
            </span>
          </h1>

          <div className="reveal mt-12 grid md:grid-cols-12 gap-8 items-end" style={{ animationDelay: "260ms" }}>
            <div className="md:col-span-6">
              <p className="font-serif-italic text-2xl md:text-3xl text-white leading-snug mb-5">
                &ldquo;Obsessed with watching people win.&rdquo;
              </p>
              <p className="text-base md:text-lg text-white/75 leading-relaxed max-w-xl">
                Custom fitness coaching for busy humans who want to slay their goals — fully digital, on your time. Personalized plans built around your goals, schedule, lifestyle, and vibe.
              </p>
            </div>

            <div className="md:col-span-6 flex flex-wrap gap-4 md:justify-end">
              <a
                href={EVERFIT_URL}
                target="_blank"
                rel="noreferrer noopener"
                data-testid="hero-cta-primary"
                className="inline-flex items-center gap-3 bg-[#FF1B91] hover:bg-[#FF3FA3] text-white px-7 py-4 text-xs font-bold uppercase tracking-[0.2em] btn-brutal btn-brutal-pink"
              >
                Join Everfit <ArrowRight size={16} weight="bold" />
              </a>
              <a
                href="#about"
                data-testid="hero-cta-secondary"
                className="inline-flex items-center gap-3 border border-white/30 hover:border-white text-white px-7 py-4 text-xs font-bold uppercase tracking-[0.2em] transition-colors"
              >
                Meet your coach
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-[10px] uppercase tracking-[0.3em] text-white/40">Scroll</span>
        <div className="w-px h-10 bg-gradient-to-b from-white/40 to-transparent" />
      </div>
    </section>
  );
}
